import { manualPageIdSchema } from "@estate-platform/domain/ids";
import { createFileRoute, getRouteApi } from "@tanstack/react-router";

import { useViewer } from "../data/hooks.ts";
import { loadManualPage } from "../manual/loaders.ts";
import { ManualPageScreen } from "../manual/manual-page.tsx";
import { ManualPending } from "../manual/pending.tsx";
import { canBrowseManual } from "../manual/permissions.ts";
import { parameterOrNotFound } from "../shell/route-parameters.ts";
import { NoAccessPage } from "../shell/status-pages.tsx";

import type { ReactElement } from "react";

const route = getRouteApi("/_app/manual/$pageId");

const Page = (): ReactElement => {
  const viewer = useViewer();
  const { pageId } = route.useParams();
  return viewer === null || !canBrowseManual(viewer) ? (
    <NoAccessPage />
  ) : (
    <ManualPageScreen viewer={viewer} pageId={pageId} />
  );
};

export const Route = createFileRoute("/_app/manual/$pageId")({
  params: {
    parse: ({ pageId }) => ({ pageId: parameterOrNotFound(manualPageIdSchema, pageId) }),
    stringify: ({ pageId }) => ({ pageId }),
  },
  loader: async ({ context, params }) => loadManualPage(context.data, params.pageId),
  pendingComponent: ManualPending,
  component: Page,
});
